import { z } from 'zod';

import { TypeCountry } from '../models/contentful-generated';
import { ContentfulSysSchema } from './contentful-sys.validator';

export const CountryEntrySchema = z.object({
  sys: ContentfulSysSchema,
  fields: z.looseObject({
    name: z.string(),
    isoCode: z.string()
  }),
  metadata: z
    .object({
      tags: z.array(z.any()).optional().nullable()
    })
    .optional()
    .nullable()
});

export function validateCountryEntry(data: TypeCountry) {
  return CountryEntrySchema.safeParse(data);
}

/**
 * Returns validation result.
 *
 * @param data
 */
export function validateCountryEntries(data: TypeCountry[]) {
  return z.array(CountryEntrySchema).safeParse(data);
}

/**
 * Returns valid entries only. In most cases, this is preferred,
 * It allows us to still show some entries instead of showing nothing when only a single entry is invalid.
 *
 * @param data
 */
export function validateAndFilterCountryEntries(data: TypeCountry[]) {
  if (!data) return [];

  return data.reduce((acc: TypeCountry[], entry) => {
    const validationResult = validateCountryEntry(entry);
    if (validationResult.success) {
      acc.push(validationResult.data as unknown as TypeCountry);
    } else {
      console.warn(
        `Validation failed for country entry with id: '${entry?.sys?.id}'. It will be filtered out. Error: ${validationResult.error.message}`
      );
    }
    return acc;
  }, []);
}
